"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  id: null,
  portalId: null,
  name: null,
  settingsModuleId: null,
  previewTemplateId: null,
  created: null,
  updated: null,
  deletedAt: null,
  folderId: null,
  author: null,
  createdById: null,
  updatedById: null,
  imageUrl: null,
  settingsValues: null,
  isReadOnly: null,
  marketplaceGoodVersionId: null,
  label: null,
  authorAt: null,
  cosObjectType: null,
  cdnPurgeEmbargoTime: null,
  assets: null,
  meta: null
}, 'Theme');

exports.default = _default;
module.exports = exports.default;